import { render } from "./BlogPostsPage.vue?vue&type=template&id=72020125&scoped=true"
import script from "./BlogPostsPage.vue?vue&type=script&lang=js"
export * from "./BlogPostsPage.vue?vue&type=script&lang=js"

import "./BlogPostsPage.vue?vue&type=style&index=0&id=72020125&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72020125"]])

export default __exports__